var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMethodsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA8F4E",
    d: "M20.39 10.707 18.95 9.548a.855.855 0 0 1-.313-.76l.2-1.839a1.642 1.642 0 0 0-1.085-1.726 1.634 1.634 0 0 0-.721-.083l-1.838.198a.854.854 0 0 1-.76-.314l-1.157-1.44a1.688 1.688 0 0 0-2.553 0l-1.157 1.44a.85.85 0 0 1-.76.314L6.972 5.14a1.634 1.634 0 0 0-1.724 1.086c-.08.231-.11.478-.082.722l.2 1.839a.853.853 0 0 1-.314.76l-1.44 1.16a1.64 1.64 0 0 0 0 2.557l1.439 1.158a.853.853 0 0 1 .313.761l-.2 1.838a1.64 1.64 0 0 0 1.806 1.81l1.836-.2a.853.853 0 0 1 .76.313l1.158 1.443a1.64 1.64 0 0 0 1.985.452c.22-.106.415-.26.568-.452l1.157-1.44a.856.856 0 0 1 .76-.314l1.835.2a1.635 1.635 0 0 0 1.807-1.808l-.2-1.84a.852.852 0 0 1 .313-.76l1.439-1.159a1.64 1.64 0 0 0 0-2.557l.002-.002Zm-8.076 3.682a1.4 1.4 0 0 1-1.589.462 1.395 1.395 0 0 1-.495-.313l-1.913-1.91a.783.783 0 1 1 1.106-1.11l1.762 1.765 3.06-4.084a.783.783 0 1 1 1.252.94l-3.183 4.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodsActive);
export default __webpack_public_path__ + "static/media/paymentMethods-active.f3654064038993e9dd0195a1b45bf255.svg";
export { ForwardRef as ReactComponent };